module.exports = __webpack_public_path__ + "img/banner04.63072071.jpg";